import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/listini'
  },
  {
    path: '/listini',
    name: 'Listini',
    component: () => import(/* webpackChunkName: "listini" */ '../views/Listini.vue')
  },
  {
    path: '/listini/edit/:id',
    name: 'ListiniEdit',
    component: () => import(/* webpackChunkName: "listini" */ '../views/ListiniEdit.vue')
  },
  {
    path: '/listiniTariffeInternazionali',
    name: 'ListiniTariffe',
    component: () => import(/* webpackChunkName: "listinitariffe" */ '../views/ListiniTariffe.vue')
  },
  {
    path: '/listiniTariffeInternazionali/edit/:id',
    name: 'ListiniTariffeEdit',
    component: () => import(/* webpackChunkName: "listinitariffe" */ '../views/ListiniTariffeEdit.vue')
  },
  {
    path: '/utenze',
    name: 'Utenze',
    component: () => import(/* webpackChunkName: "utenze" */ '../views/Utenze.vue')
  },
  {
    path: '/utenze/edit/:id',
    name: 'UtenzeEdit',
    component: () => import(/* webpackChunkName: "utenze" */ '../views/UtenzeEdit.vue')
  },
  {
    path: '/numerazioni',
    name: 'Numerazioni',
    component: () => import(/* webpackChunkName: "utenze" */ '../views/Numerazioni.vue')
  },
  {
    path: '/numerazioni/edit/:id',
    name: 'NumerazioniEdit',
    component: () => import(/* webpackChunkName: "utenze" */ '../views/NumerazioniEdit.vue')
  },
  {
    path: '/fornitori',
    name: 'Fornitori',
    component: () => import(/* webpackChunkName: "fornitori" */ '../views/Fornitori.vue')
  },
  {
    path: '/fornitori/edit/:id',
    name: 'FornitoriEdit',
    component: () => import(/* webpackChunkName: "fornitori" */ '../views/FornitoriEdit.vue')
  },
  {
    path: '/cdr_upload',
    name: 'CdrUploadPage',
    component: () => import(/* webpackChunkName: "cdr" */ '../views/CdrUpload.vue')
  },
  {
    path: '/cdrDettaglio',
    name: 'CdrDettaglioPage',
    component: () => import(/* webpackChunkName: "cdr"  */ '../views/CdrDettaglio.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
